import React from 'react';
import { Card } from "react-bootstrap";
import face_gyorgy_karolyi from "../../assets/img/face_gyorgy_karolyi.png";
import ShowMoreText from "react-show-more-text";
import proj_double_road_closure from "../../assets/img/proj_double_road_closure.png";

const Gyorgy_Karolyi_double_road_closure = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_double_road_closure} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_gyorgy_karolyi}
              /* this will be the text on the banner */
              alt="Optimizing traffic signals at one sided double road closure"
            />{" "}
            <p className="text7">György Károlyi</p>
            <br />
            <p className="text8">
              Professor{" "}
            </p>
            <p className="text8">Institute of Nuclear Techniques, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Even one sided road closures have a great impact on traffic flow, often
            leading to traffic jams. It is hence important to optimize the traffic
            signals in order to achieve maximum through traffic. Double road
            closures may occur for example when bridge ends are under maintenance at
            the same time. During this project, traffic signals at one sided double
            road closures are optimized as a function of several parameters using
            either continuous or discrete modelling. In the continuous case,
            analytical formulation is expected to be obtained that results in the
            optimal program of the traffic signals as a function of the problem
            parameters, e.g., the length of and distance between the closures, the
            speed and density of the traffic flow. The more realistic discrete model
            can computationally tackle other factors, like random density and speed
            of traffic, or individual driving practice using an agent-based approach.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Gyorgy_Karolyi_double_road_closure;